import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const ReportOperationsDrawerWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "report-operations-drawer-wrapper",
  },
)`
  width: calc(100% + 24px);
  margin-inline-start: -24px;
  display: flex;
  flex-direction: column;
  text-align: start;

  /* & button {
      color: ${greyMui._900};
      border-radius: 0;
      display: block;
      padding-inline-start: 25px;
      margin-bottom: 10px;
  
      & div {
        justify-content: space-between;
        font-size: 16px;
      }
  
      & svg {
        visibility: hidden;
      }
  
      &:hover svg {
        visibility: visible;
      }
    } */
`;
